"use client";
import { type ReactNode, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function Toast({
  id,
  children,
}: {
  id: string;
  isOpen?: boolean;
  children: ReactNode;
}) {
  const ref = useRef<Element | null>(null);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    ref.current = document.querySelector<HTMLElement>("body");
    setMounted(true);
  }, []);
  return mounted && ref.current ? (
    createPortal(
      <>
        <input type="checkbox" id={id} className="modal-toggle" />
        <label htmlFor={id} className="modal cursor-pointer">
          <label className="toast">
            <div className="alert alert-success">
              <div className="whitespace-nowrap">{children}</div>
            </div>
          </label>
        </label>
      </>,
      ref.current,
    )
  ) : (
    <></>
  );
}
